import { LineItem, Lot } from 'types';

import { calcBaselinePrice } from './calcBaselinePrice';

export const calcTotalBaselinePrice = (lot: Lot, isCounted: (_item: LineItem) => boolean = () => true): number => {
  if (!lot?.line_items?.length) return 0.0;

  return lot.line_items
    .filter(isCounted)
    .reduce((total, item) => total + (calcBaselinePrice(item) || 0), 0);
};
